

















































































































import {
  courseList,
  deleteCourse,
  setCourseStatus,
  setRelateCourse,
  checkCourseStudent,
  setCourseVisibleApi,
} from "@/api/course";
import { subjectList } from "@/api/subject";
import sortEditor from "./sortEditor.vue";
import { PageModule } from "@/store/module/page";
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "storeCourseList",
  components: {
    sortEditor,
  },
})
export default class extends Vue {
  searchInfo: any = {
    sales_status: -1,
  };
  courseList: any[] = [];
  subjectsList: any[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    const cache = PageModule.pageInfo.storeCourse;
    if (cache.pagec) {
      this.page = cache.pagec;
      this.getList({
        page: cache.pagec,
        page_size: this.pageSize,
      });
    } else {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    }
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.course_name) {
      option.course_name = this.searchInfo.course_name;
    }
    if (this.searchInfo.subject_id >= 0) {
      option.subject_id = this.searchInfo.subject_id;
    }
    if (this.searchInfo.sales_status >= 0) {
      option.sales_status = this.searchInfo.sales_status;
    }
    courseList(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          item.sales_status = item.sales_status === 1;
          item.is_show = item.is_show === 1;
        });
        this.tableData = res.data.list;
        this.page = params.page;
        this.total = res.data.total;
      }
    });
    subjectList({
      page: 1,
      page_size: 100,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.subjectsList = [...res.data.list];
      }
    });
  }
  handleAddCourse() {
    this.$router.push({
      name: "storeCourseDetail",
      query: {
        id: "0",
      },
    });
  }
  handleSearchCourse() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  toDetail(row: any) {
    this.$router.push({
      name: "storeCourseDetail",
      query: {
        id: row.course_id,
        type: "1",
      },
    });
  }
  confirmDelete(row: any) {
    checkCourseStudent({ course_id: row.course_id }).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.list.length > 0) {
          let str = "";
          res.data.list.map((item: any) => {
            str = str + item.name + "、";
          });
          str = str.replace(/.$/, "");
          this.$alert(
            `以下学员结课后，才能删除。${str}`,
            `删除 - ${row.course_name}`,
            {
              confirmButtonText: "关闭",
              confirmButtonClass: "mwow-button-filled mini",
              type: "warning",
              iconClass: "mwow-icon-error",
            }
          );
        } else {
          this.$confirm(
            `删除后，课程的所有数据不能恢复，同时涉及到该课程的点名签到也无法进行。`,
            `删除 - ${row.course_name}`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
            }
          )
            .then(() => {
              this.handleDelete(row.course_id);
            })
            .catch(() => {});
        }
      }
    });
  }
  handleDelete(cid: number) {
    deleteCourse({ course_id: cid }).then((res: any) => {
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        this.handleRefresh("delete");
      } else {
        this.$message({
          type: "error",
          message: "删除失败!" + res.message,
        });
      }
    });
  }
  confirmSetStatus(row: any) {
    if (!row.sales_status) {
      setRelateCourse({ course_id: row.course_id }).then((result: any) => {
        if (result.error_code === 0) {
          let str = "";
          result.data.list.map((i: any) => {
            str = str + i.combo_product_name + "、";
          });
          str = str.replace(/.$/, "");
          if (str) {
            const title = `关闭购买 - ${row.course_name}`;
            const content = `停止购买此课程后，以下包含此课程的套餐都将停止购买。${str}`;
            this.$confirm(content, title, {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              type: "warning",
            })
              .then(() => {
                this.handleSetStatus(row.course_id, 2);
              })
              .catch(() => {
                this.getList({
                  page: this.page,
                  page_size: this.pageSize,
                });
              });
          } else {
            this.handleSetStatus(row.course_id, 2);
          }
        }
      });
    } else {
      this.handleSetStatus(row.course_id, 1);
    }
  }
  handleSetStatus(cid: number, status: number) {
    setCourseStatus({
      course_id: cid,
      sales_status: status,
    }).then((res: any) => {
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
      } else {
        this.$message({
          type: "error",
          message: "修改失败!" + res.message,
        });
      }
    });
  }
  setCourseVisible(row: any) {
    setCourseVisibleApi({
      course_id: row.course_id,
      is_show: row.is_show ? 1 : 2,
    })
      .then((res: any) => {
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
        } else {
          this.$message({
            type: "error",
            message: "修改失败!" + res.message,
          });
        }
      })
      .catch(() => {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      });
  }
  handleRefresh(type?: string) {
    let page = this.page;
    if (
      type === "delete" &&
      (this.page - 1) * this.pageSize + 1 === this.total
    ) {
      page = page - 1;
    }
    this.getList({
      page: page > 0 ? page : 1,
      page_size: this.pageSize,
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
    PageModule.SET_PAGE_INFO({
      name: "storeCourse",
      key: "pagec",
      value: e,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
